import PostTrip from "../Trips/PostTrip";

const DesktopPost = ({ currentUser }) => (
  <div className="d-page">
    <div className="d-container-sm">
      <PostTrip currentUser={currentUser}/>
    </div>
  </div>
);

export default DesktopPost;
